/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';
import { ApiResponse } from 'shared/interfaces/site';

export const getOrganizations =
	(): Promise<ApiResponse> => {
		return apiClient.get('/organizations', {
			params: {
				pageSize: 100,
				sort: 'name',
			},
		});
	};

export const getOrganizationsHasEntityBrand =
	(): Promise<any> => {
		return apiClient.get('/brands/parent/organizations');
	};

const getOrganizationsHasEntitiesBrand = (
	organizations: any,
	organizationIds: { ids: string[] }
) => {
	if (
		organizations &&
		organizations.rows &&
		Array.isArray(organizations.rows) &&
		organizationIds &&
		organizationIds.ids &&
		Array.isArray(organizationIds.ids)
	) {
		const intersection = organizations.rows.filter(
			(obj: any) => organizationIds.ids.includes(obj.id)
		);

		return intersection;
	}
};

export const useOrganizationsHasBrands = () => {
	const { data: organizationIds } = useQuery({
		queryKey: ['organizationIds'],
		queryFn: getOrganizationsHasEntityBrand,
	});

	const { data, isFetching, isFetched } = useQuery({
		queryKey: ['organizations'],
		queryFn: () => getOrganizations(),
	});

	return {
		data: data
			? getOrganizationsHasEntitiesBrand(
					data,
					organizationIds
				)
			: [],
		isLoading: isFetching && !isFetched,
		isFetched,
		total: data?.total,
		page: data?.page,
		pageSize: data?.pageSize,
		totalPages: data?.totalPages,
	};
};
